import React, { Fragment, useEffect, useState, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import MainPagetitle from '../../layouts/MainPagetitle';
import ClipLoader from 'react-spinners/ClipLoader';
import AdminSubscriberService from '../../../API/Services/AdminService/AdminSubscriberService';
import PriceComponent from '../../components/Price/PriceComponent';
import swal from "sweetalert";
import DateComponent from '../../components/date/DateFormat';
import { safeJsonParse } from "../../../utils/subscriptionAccess";

const SubscriptionList = () => {
    const navigate = useNavigate();
    const tableRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const SyestemUserRole = localStorage.getItem("user") ? JSON.parse(localStorage.getItem("user")).role : "";
    const [currentPage, setCurrentPage] = useState(1);
    const recordsPage = 100;
    const lastIndex = currentPage * recordsPage;
    const [npage, setNpage] = useState(0);
    const number = [...Array(npage + 1).keys()].slice(1);
    const [subscriptionList, setSubscriptionList] = useState([]);
    const [subscriptionListCount, setSubscriptionListCount] = useState("");

    // Dynamic responsive calculation of sticky column offsets
    useEffect(() => {
        const table = tableRef.current;
        if (!table) return;

        const updateOffsets = () => {
            const headerRow = table.querySelector("thead tr");
            if (!headerRow) return;
            const ths = headerRow.children;
            if (ths.length < 4) return;

            const w0 = ths[0].offsetWidth || 50;
            const w1 = ths[1].offsetWidth || 100;
            const w2 = ths[2].offsetWidth || 110;

            table.style.setProperty("--col1-left", "0px");
            table.style.setProperty("--col2-left", `${w0}px`);
            table.style.setProperty("--col3-left", `${w0 + w1}px`);
            table.style.setProperty("--col4-left", `${w0 + w1 + w2}px`);
        };

        updateOffsets();
        const timer1 = setTimeout(updateOffsets, 60);
        const timer2 = setTimeout(updateOffsets, 300);

        let resizeObserver;
        if (typeof ResizeObserver !== "undefined") {
            resizeObserver = new ResizeObserver(() => {
                updateOffsets();
            });
            resizeObserver.observe(table);
        }

        window.addEventListener("resize", updateOffsets);

        return () => {
            clearTimeout(timer1);
            clearTimeout(timer2);
            if (resizeObserver) resizeObserver.disconnect();
            window.removeEventListener("resize", updateOffsets);
        };
    }, [subscriptionList, isLoading]);

    const prePage = () => {
        if (currentPage !== 1) {
            setCurrentPage(currentPage - 1);
        }
    };

    const changeCPage = (id) => {
        setCurrentPage(id);
    };

    const nextPage = () => {
        if (currentPage !== npage) {
            setCurrentPage(currentPage + 1);
        }
    };

    useEffect(() => {
        const is_subscribed = safeJsonParse(localStorage.getItem("is_subscribed"));
        const new_user = safeJsonParse(localStorage.getItem("new_user"));
        
        if (localStorage.getItem("usertoken")) {
            if (Number(is_subscribed) === 1 && Number(new_user) === 1) {
                GetSubscriptionList();
            } else {
                navigate("/subscriptionplan");
            }
        } else {
            navigate("/");
        }
    }, [currentPage]);

    const GetSubscriptionList = async () => {
        setIsLoading(true);
        try {
            const response = await AdminSubscriberService.getSubscriptionList();
            const responseData = await response.json();
            if (responseData.status === true) {
                setSubscriptionList(responseData.data);
                setNpage(Math.ceil(responseData.data.length / recordsPage));
                setSubscriptionListCount(responseData.data.length);
                setIsLoading(false);
            } else {
                setIsLoading(false);
            }
        } catch (error) {
            setIsLoading(false);
            if (error.name === "HTTPError") {
            }
        }
    };

    const handleSubscribePLan = () => {
        navigate("/subscriptionplan");
    };

    const HandleCancelSubscriptionList = async(Id) => {
        setIsLoading(true);
        try {
            const response = await AdminSubscriberService.subscribCancel(Id);
            const responseData = await response.json();
            if (responseData.status === true) {
                GetSubscriptionList();
                setIsLoading(false);
            } else {
                swal(responseData.message).then((willDelete) => {
                    if (willDelete) {
                        GetSubscriptionList();
                        setIsLoading(false);
                    }
                });
            }
        } catch (error) {
            setIsLoading(false);
            if (error.name === "HTTPError") {
            }
        }
    };

    return (
        <Fragment>
            <MainPagetitle mainTitle="Subscription List" pageTitle="Subscription List" parentTitle="Home" />
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div className="tbl-caption d-flex justify-content-between text-wrap align-items-center pb-0">
                                        <div className="d-flex text-nowrap justify-content-between align-items-center">
                                            <h4 className="heading mb-0">Subscription List</h4>
                                        </div>
                                        {(SyestemUserRole != "Admin" || SyestemUserRole != "Staff") && (
                                            <div className="d-flex justify-content-between">
                                                <button 
                                                    className="btn btn-success btn-sm me-1" 
                                                    style={{
                                                        color: "white", 
                                                        fontWeight: "bolder", 
                                                        background: "black", 
                                                        border: "none"
                                                    }} 
                                                    onClick={handleSubscribePLan} 
                                                    title="Subscription Plan"
                                                >
                                                    Subscription Plan
                                                </button>
                                            </div> 
                                        )}
                                    </div>
                                    <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                                        <div className="dataTables_info">
                                            Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                                            {subscriptionListCount} entries
                                        </div>
                                        <div
                                            className="dataTables_paginate paging_simple_numbers justify-content-center"
                                            id="example2_paginate"
                                        >
                                            <Link
                                                className="paginate_button previous disabled"
                                                to="#"
                                                onClick={prePage}
                                            >
                                                <i className="fa-solid fa-angle-left" />
                                            </Link>
                                            <span>
                                                {number.map((n, i) => {
                                                    if (number.length > 4) {
                                                        if (
                                                            i === 0 ||
                                                            i === number.length - 1 ||
                                                            Math.abs(currentPage - n) <= 1 ||
                                                            (i === 1 && n === 2) ||
                                                            (i === number.length - 2 &&
                                                                n === number.length - 1)
                                                        ) {
                                                            return (
                                                                <Link
                                                                    className={`paginate_button ${currentPage === n ? "current" : ""
                                                                        } `}
                                                                    key={i}
                                                                    onClick={() => changeCPage(n)}
                                                                >
                                                                    {n}
                                                                </Link>
                                                            );
                                                        } else if (i === 1 || i === number.length - 2) {
                                                            return <span key={i}>...</span>;
                                                        } else {
                                                            return null;
                                                        }
                                                    } else {
                                                        return (
                                                            <Link
                                                                className={`paginate_button ${currentPage === n ? "current" : ""
                                                                    } `}
                                                                key={i}
                                                                onClick={() => changeCPage(n)}
                                                            >
                                                                {n}
                                                            </Link>
                                                        );
                                                    }
                                                })}
                                            </span>

                                            <Link
                                                className="paginate_button next"
                                                to="#"
                                                onClick={nextPage}
                                            >
                                                <i className="fa-solid fa-angle-right" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div
                                        id="employee-tbl_wrapper"
                                        className="dataTables_wrapper no-footer"
                                    >
                                        {isLoading ? (
                                            <div className="d-flex justify-content-center align-items-center mb-5">
                                                <ClipLoader color="#4474fc" />
                                            </div>
                                        ) : (
                                            <table
                                                id="empoloyees-tblwrapper"
                                                ref={tableRef}
                                                className="table ItemsCheckboxSec dataTable no-footer mb-0 subscription-list-table"
                                            >
                                                <thead>
                                                    <tr style={{ textAlign: "center" }}>
                                                        <th>No.</th>
                                                        <th>Name</th>
                                                        <th>Last Name</th>
                                                        <th>Email</th>
                                                        <th>Subscription Title</th>
                                                        <th>Subscription Type</th>
                                                        <th>Subscription Status</th>
                                                        <th>Subscription Price</th>
                                                        <th>Payment Status</th>
                                                        <th>Subscription Start</th>
                                                        <th>Cancellation Request Date</th>
                                                        <th>Subscription Expiration</th>
                                                        <th>Subscription Content</th>
                                                        {/* <th>Action</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {subscriptionList !== null && subscriptionList.length > 0 ? (
                                                        subscriptionList.map((element, index) => (
                                                            <tr key={element.id || index} style={{ textAlign: "center" }}>
                                                                <td>{index + 1}</td>
                                                                <td>{element.user_name}</td>
                                                                <td>{element.user_last_name}</td>
                                                                <td>{element.user_email}</td>
                                                                <td>{element.subscription?.title}</td>
                                                                <td>{element.subscription?.type}</td>
                                                                <td>
                                                                    {element.subscription_status === "scheduled_for_cancellation" ? (
                                                                        <span className="badge" style={{ backgroundColor: "#fef3c7", color: "#92400e", border: "1px solid #fde68a" }}>
                                                                            Scheduled for Cancellation
                                                                        </span>
                                                                    ) : element.subscription_status === "active" ? (
                                                                        <span className="badge" style={{ backgroundColor: "#e8f8ee", color: "#1f9254" }}>
                                                                            Active
                                                                        </span>
                                                                    ) : element.subscription_status === "cancelled" ? (
                                                                        <span className="badge" style={{ backgroundColor: "#fdecec", color: "#d93025" }}>
                                                                            Cancelled
                                                                        </span>
                                                                    ) : (
                                                                        element.subscription_status
                                                                    )}
                                                                </td>
                                                                <td>{<PriceComponent price={element.price} />}</td>
                                                                <td>{element.payment_status}</td>
                                                                <td><DateComponent date={element.subscription_start_at} /></td>
                                                                <td>{element.cancellation_requested_at ? <DateComponent date={element.cancellation_requested_at} /> : "—"}</td>
                                                                <td>{element.subscription_end_at ? <DateComponent date={element.subscription_end_at} /> : (element.subscription_renewed_at ? <DateComponent date={element.subscription_renewed_at} /> : "—")}</td>
                                                                <td>{element.subscription_content}</td>
                                                            </tr>
                                                        ))) : (
                                                        <tr>
                                                            <td colSpan="13" style={{ textAlign: "center" }}>
                                                                No data found
                                                            </td>
                                                        </tr>)}
                                                </tbody>
                                            </table>
                                        )}
                                    </div>
                                </div>
                                <div className="d-sm-flex text-center justify-content-between align-items-center dataTables_wrapper no-footer">
                                    <div className="dataTables_info">
                                        Showing {lastIndex - recordsPage + 1} to {lastIndex} of{" "}
                                        {subscriptionListCount} entries
                                    </div>
                                    <div
                                        className="dataTables_paginate paging_simple_numbers justify-content-center"
                                        id="example2_paginate"
                                    >
                                        <Link
                                            className="paginate_button previous disabled"
                                            to="#"
                                            onClick={prePage}
                                        >
                                            <i className="fa-solid fa-angle-left" />
                                        </Link>
                                        <span>
                                            {number.map((n, i) => {
                                                if (number.length > 4) {
                                                    if (
                                                        i === 0 ||
                                                        i === number.length - 1 ||
                                                        Math.abs(currentPage - n) <= 1 ||
                                                        (i === 1 && n === 2) ||
                                                        (i === number.length - 2 &&
                                                            n === number.length - 1)
                                                    ) {
                                                        return (
                                                            <Link
                                                                className={`paginate_button ${currentPage === n ? "current" : ""
                                                                    } `}
                                                                key={i}
                                                                onClick={() => changeCPage(n)}
                                                            >
                                                                {n}
                                                            </Link>
                                                        );
                                                    } else if (i === 1 || i === number.length - 2) {
                                                        return <span key={i}>...</span>;
                                                    } else {
                                                        return null;
                                                    }
                                                } else {
                                                    return (
                                                        <Link
                                                            className={`paginate_button ${currentPage === n ? "current" : ""
                                                                } `}
                                                            key={i}
                                                            onClick={() => changeCPage(n)}
                                                        >
                                                            {n}
                                                        </Link>
                                                    );
                                                }
                                            })}
                                        </span>

                                        <Link
                                            className="paginate_button next"
                                            to="#"
                                            onClick={nextPage}
                                        >
                                            <i className="fa-solid fa-angle-right" />
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    )
}

export default SubscriptionList;
